import * as React from 'react';
import { Fragment } from 'react';

import classNames from 'classnames';
import $ from 'jquery';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Grid, VisuallyHidden } from '@coursera/cds-core';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { ProfileArea } from 'bundles/discussions';
import CreatedTimeLink from 'bundles/discussions/components/CreatedTimeLink';
import EditIndicator from 'bundles/discussions/components/EditIndicator';
import ModerationDropdown from 'bundles/discussions/components/ModerationDropdown';
import ReplyButton from 'bundles/discussions/components/ReplyButton';
import SoftDelete from 'bundles/discussions/components/SoftDelete';
import ReplyProfileInformation from 'bundles/discussions/components/profiles/ReplyProfileInformation';
import JumpToReply from 'bundles/discussions/components/repliesList/JumpToReply';
import ReplyCMLEdit from 'bundles/discussions/components/repliesList/ReplyCMLEdit';
import ReplyListItemActions from 'bundles/discussions/components/repliesList/ReplyListItemActions';
import { naptimeForumTypes } from 'bundles/discussions/constants';
import { replyPropType } from 'bundles/discussions/lib/propTypes';
import { formatReplyLegendId, getProfileLinkId } from 'bundles/discussions/utils/threadUtils';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ReplyListItem';

const SCROLL_TRANSITION = 1500;
const OFFSET_TOP_PX = 10;

export class ReplyListItem extends React.LegacyComponentWithChildren {
  static propTypes = {
    reply: replyPropType.isRequired,
    commentsEnabled: PropTypes.bool,
    toggleComments: PropTypes.func,
    answerId: PropTypes.string,
    commentId: PropTypes.string,
    commentCount: PropTypes.number,
    className: PropTypes.string,
    children: PropTypes.node,
    isHighlighted: PropTypes.bool,
    isQuestionLoaded: PropTypes.bool,
    forumLink: PropTypes.string,
    forumType: PropTypes.string,
    showJumpLink: PropTypes.bool,
    hideUndoDelete: PropTypes.bool,
    fetchAnswerPosition: PropTypes.func.isRequired,
    handleModerationActionClick: PropTypes.func,
    handleModerationSuccess: PropTypes.func,
    isNewestReply: PropTypes.bool,
    isFocused: PropTypes.bool,
    onDeleteClick: PropTypes.func,
    onDeleteSuccess: PropTypes.func,
    isReadOnlyAfterSessionEnd: PropTypes.bool,
  };

  firstControlComponent = React.createRef<HTMLLIElement>();

  state = {
    announceEditSuccessNotification: false,
    announceReportedSuccessNotification: false,
    announceReportResolvedSuccessNotification: false,
  };

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isQuestionLoaded' does not exist on type... Remove this comment to see the full error message
    const { isQuestionLoaded, isFocused } = this.props;
    if (this.isDeepLinked() && isQuestionLoaded) {
      this.scrollToLocation();
    }

    if (isFocused) {
      this.focusOnProfile();
    }
  }

  componentDidUpdate(prevProps: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isFocused' does not exist on type... Remove this comment to see the full error message
    if (!prevProps.isFocused && this.props.isFocused) {
      this.focusOnProfile();
    }
  }

  focusOnProfile = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<...'.
    const { reply } = this.props;
    const profileLinkId = getProfileLinkId(reply);

    if (this.firstControlComponent?.current) {
      const profileLink = this.firstControlComponent.current?.querySelector(`#${profileLinkId}`);
      (profileLink as HTMLAnchorElement)?.focus();
    }
  };

  isDeepLinked() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
    const { reply, commentId, answerId } = this.props;
    return (
      (commentId && reply.type === 'comment' && reply.forumCommentId === commentId) ||
      (answerId && !commentId && reply.type === 'answer' && reply.topLevelForumAnswerId === answerId)
    );
  }

  scrollToLocation() {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const { reply } = this.props;

    const replyLegendIdSelector = `#${formatReplyLegendId(reply)}`;

    const yPosition = $(replyLegendIdSelector)?.offset()?.top || 0;

    const mainContainer = $('#main-container');
    const inMainCourseWrapper = mainContainer.find(`${replyLegendIdSelector}`);

    // We use deep linking on several different pages, some of which have different scrolling DOM elements. Try for the
    // elements on the main discussions page separately, since scroll is handled differently.
    if ($('main.course-content').length) {
      $('html,body').animate(
        {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          scrollTop: yPosition + $('body').scrollTop() - $('body').offset().top - OFFSET_TOP_PX,
        },
        SCROLL_TRANSITION
      );
    } else if (inMainCourseWrapper.length) {
      // scroll to the reply in the main course wrapper
      mainContainer.animate(
        {
          scrollTop: yPosition,
        },
        SCROLL_TRANSITION
      );
    } else if ($('body').css('overflow') !== 'hidden') {
      const headerOffset = $('.rc-PageHeader').length ? $('.rc-PageHeader')[0].offsetHeight : 0;
      $('body').animate(
        {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          scrollTop: yPosition + $('body').scrollTop() - $('body').offset().top - headerOffset - OFFSET_TOP_PX,
        },
        SCROLL_TRANSITION
      );
    }
  }

  handleEditClick = () => {
    this.setState({
      announceEditSuccessNotification: false,
    });
  };

  handleEditSuccess = () => {
    this.setState({
      announceEditSuccessNotification: true,
    });
    this.focusOnProfile();
  };

  handleFlaggingClick = () => {
    this.setState({
      announceReportedSuccessNotification: false,
      announceReportResolvedSuccessNotification: false,
    });
  };

  handleFlaggingSuccess = (isReportResolveSuccess: boolean) => {
    if (isReportResolveSuccess) {
      this.setState({
        announceReportResolvedSuccessNotification: true,
      });
    } else {
      this.setState({
        announceReportedSuccessNotification: true,
      });
    }
  };

  renderShowToggle() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'commentsEnabled' does not exist on type ... Remove this comment to see the full error message
    const { commentsEnabled, commentCount, toggleComments, reply } = this.props;
    const showText = _t('Show') + ` ${commentCount} ` + (commentCount === 1 ? _t('Reply') : _t('Replies'));
    const hideText = _t('Hide') + ` ${commentCount} ` + (commentCount === 1 ? _t('Reply') : _t('Replies'));
    const creator = reply.creator;

    const showMessage = <ReplyButton handleClick={toggleComments} text={showText} creator={creator} />;

    const hideMessage = <ReplyButton handleClick={toggleComments} text={hideText} creator={creator} />;

    const replyLink = <ReplyButton handleClick={toggleComments} text={_t('Reply')} creator={creator} />;

    const hideLink = <ReplyButton handleClick={toggleComments} text={_t('Hide')} creator={creator} />;

    if (commentsEnabled) {
      return commentCount ? hideMessage : hideLink;
    } else {
      return commentCount ? showMessage : replyLink;
    }
  }

  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'reply' does not exist on type 'Readonly<... Remove this comment to see the full error message
      reply,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumLink' does not exist on type 'Reado... Remove this comment to see the full error message
      forumLink,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
      forumType,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'showJumpLink' does not exist on type 'Re... Remove this comment to see the full error message
      showJumpLink,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isHighlighted' does not exist on type 'R... Remove this comment to see the full error message
      isHighlighted,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideUndoDelete' does not exist on type '... Remove this comment to see the full error message
      hideUndoDelete,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fetchAnswerPosition' does not exist on t... Remove this comment to see the full error message
      fetchAnswerPosition,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
      className,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteClick' does not exist on t... Remove this comment to see the full error message
      onDeleteClick,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onDeleteSuccess' does not exist on t... Remove this comment to see the full error message
      onDeleteSuccess,
      children,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isReadOnlyAfterSessionEnd' does not exist on type 'Readonly<... Remove this comment to see the full error message
      isReadOnlyAfterSessionEnd,
    } = this.props;
    const { creator } = reply;
    // TODO: Remove animation
    if (reply.hide) {
      return null;
    }

    const replyContainerClasses = classNames(
      'horizontal-box',
      {
        'bgcolor-primary-light': this.isDeepLinked(),
      },
      'reply-content'
    );

    const replyClasses = classNames('rc-ReplyComponent', className);

    const isGradedDiscussionPrompt = forumType === naptimeForumTypes.gradedDiscussionPrompt;
    const replyLegendId = formatReplyLegendId(reply);
    const profileLinkId = getProfileLinkId(reply);

    const moderationDropdown = (
      <ModerationDropdown
        creator={creator}
        post={reply}
        isHighlighted={isHighlighted}
        forumLink={forumLink}
        isGradedDiscussionPrompt={isGradedDiscussionPrompt}
        ariaDescribedBy={replyLegendId}
        onEditClick={this.handleEditClick}
        onDeleteClick={onDeleteClick}
        onDeleteSuccess={onDeleteSuccess}
        onFlaggingClick={this.handleFlaggingClick}
        onFlaggingSuccess={this.handleFlaggingSuccess}
      />
    );

    return (
      <li className={replyClasses} ref={this.firstControlComponent} id={`${replyLegendId}-comment`}>
        <div id={replyLegendId} className="screenreader-only pii-hide">
          <FormattedMessage message={_t("{name}'s Post")} name={reply.creator?.fullName} />
        </div>
        <VisuallyHidden role="status" component="span" className="rc-A11yScreenReaderOnly">
          {this.state.announceEditSuccessNotification && _t('Reply edited successfully.')}
          {this.state.announceReportedSuccessNotification && _t('Reply reported successfully.')}
          {this.state.announceReportResolvedSuccessNotification && _t('Reply report resolved successfully.')}
        </VisuallyHidden>
        <div className={replyContainerClasses}>
          {reply.showEditor && (
            <Fragment>
              <div className="profile">
                <ProfileArea
                  courseRole={reply.creator?.courseRole}
                  externalUserId={reply.creator?.externalUserId}
                  fullName={reply.creator?.fullName}
                  helperStatus={reply.creator?.helperStatus}
                  profileImageUrl={reply.creator?.isDefaultPhoto ? '' : reply.creator?.photoUrl || ''}
                  profileLinkId={profileLinkId}
                />
              </div>
              <div className="flex-1 preview-container">
                {moderationDropdown}
                {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ reply: any; }' is not assignable to type '... Remove this comment to see the full error message */}
                <ReplyCMLEdit reply={reply} onSubmitSuccess={this.handleEditSuccess} />
              </div>
            </Fragment>
          )}

          {!reply.showEditor && (
            <div className="flex-1 preview-container with-editor">
              <Grid
                direction="row"
                alignItems="center"
                container
                className="metadata caption-text color-secondary-text"
                spacing={24}
              >
                <Grid className="profile" item>
                  <ReplyProfileInformation
                    courseRole={reply.creator?.courseRole}
                    externalUserId={reply.creator?.externalUserId}
                    fullName={reply.creator?.fullName}
                    helperStatus={reply.creator?.helperStatus}
                    profileImageUrl={reply.creator?.isDefaultPhoto ? '' : reply.creator?.photoUrl || ''}
                    profileLinkId={profileLinkId}
                  />
                </Grid>
                <Grid item>
                  <CreatedTimeLink post={reply} forumLink={forumLink} isClickable={!isGradedDiscussionPrompt} />
                  <EditIndicator post={reply} />
                </Grid>
              </Grid>

              {/* Moderation Dropwdown must be rendered after reply content */}
              {!isReadOnlyAfterSessionEnd && moderationDropdown}

              <ReplyListItemActions
                reply={reply}
                replyLegendId={replyLegendId}
                isReadOnlyAfterSessionEnd={isReadOnlyAfterSessionEnd}
                toggleButton={this.renderShowToggle()}
                jumpLink={
                  showJumpLink && (
                    <JumpToReply reply={reply} forumLink={forumLink} fetchAnswerPosition={fetchAnswerPosition} />
                  )
                }
              />
            </div>
          )}
        </div>
        {reply.state.deleted && <SoftDelete entry={reply} hideUndoDelete={hideUndoDelete} />}
        {children}
      </li>
    );
  }
}

export default ReplyListItem;
